/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: email-recipients-list-component.ts
 *
 * Created by randysorensen on 4/19/18.
 */

function EmailRecipientsListController(this: JS5Object,
                                       _: JS5Object,
                                       $timeout: JS5Function,
                                       uiGridConstants: JS5Object,
                                       ModalService: JS5Object,
                                       UtilsService: JS5Object) {

    const getRecipientsList = () => {
        let recipientsList;
        if (this.modelProp) {
            recipientsList = _.get(this.ngModel, this.modelProp);
        } else {
            recipientsList = _.get(this, 'ngModel');
        }
        return recipientsList;
    };

    const initGrid = () => {
        this.gridOptions = {
            rowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: true,
            enableColumnResizing: true,
            enablePaginationControls: false,
            enableSorting: true,
            enableColumnMenus: false,
            enableFullRowSelection: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            multiSelect: true,
            onRegisterApi: (gridApi: JS5Object) => {
                this.gridApi = gridApi;
            },
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
        };

        this.gridOptions.columnDefs = [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableSorting: false,
                enableColumnResizing: false,
                headerCellTemplate: 'components/visual/grid/header-check-mark-component-template.html',
                cellTemplate: 'components/visual/grid/check-mark-template.html'
            },
            {
                field: 'contact.firstName',
                type: 'string',
                width: '15%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 2
                },
                displayName: 'First Name',
            },
            {
                field: 'contact.lastName',
                type: 'string',
                width: '17.5%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 1
                },
                displayName: 'Last Name',
            },
            {
                field: 'contact.emailAddress',
                type: 'string',
                width: '*',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 3
                },
                displayName: 'Email Address',
            },
            {
                field: 'applicableNetworks',
                type: 'string',
                width: '20%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 4
                },
                cellTemplate: 'components/visual/emailRecipientsList/gridTemplates/networks-list-cell-template.html',
                displayName: 'Networks',
            },
            {
                field: 'longFormFlag',
                type: 'string',
                width: '12%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 5
                },
                displayName: 'Long Form',
            },
            {
                field: 'shortFormFlag',
                type: 'string',
                width: '12%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 6
                },
                displayName: 'Short Form',
            },
        ];
    };

    this.onSelectAllToggled = ($event: JS5Object) => {
        if (this.gridApi.selection.getSelectAllState()) {
            this.gridApi.selection.clearSelectedRows();
        } else {
            this.gridApi.selection.selectAllRows();
        }
    };

    const onUpdateRecipient = (recipient: JS5Object) => {
        let existingRecipient = _.find(getRecipientsList(), {
            contact: recipient.contact,
        });

        if (existingRecipient === undefined) {
            console.warn('Unable to update recipient:');
            console.warn(recipient);
        } else if (UtilsService.compareBasic(existingRecipient, recipient) !== 0) {
            existingRecipient.applicableNetworks = recipient.applicableNetworks;
            existingRecipient.longFormFlag = recipient.longFormFlag;
            existingRecipient.shortFormFlag = recipient.shortFormFlag;

            this.editorForm.$setDirty();
        }
    };

    this.onRowDblClick = (row: JS5Object) => {
        ModalService.showPartnerEmailRecipientModal(row.entity, onUpdateRecipient);
    };

    const contactsSelected = (selectedContacts: JS5Object) => {
        _.forEach(selectedContacts, (contact: JS5Object) => {
            // at least one contact added - dirty the form
            this.editorForm.$setDirty();

            getRecipientsList().push({
                contact: contact,
                longFormFlag: true,
                shortFormFlag: true,
                applicableNetworks: []
            });
        });
    };

    this.onAddRecipientsClick = ($event: JS5Object) => {
        const existingContactIds: number[] = _.map(getRecipientsList(), 'contact.id');
        ModalService.showContactsSelectModal(existingContactIds, contactsSelected);

        // defocus button
        $event.target.blur();
    };

    this.onRemoveRecipientsClick = ($event: JS5Object) => {
        const selectedRecipients = this.gridApi.selection.getSelectedRows();
        _.forEach(selectedRecipients, (recipient: JS5Object) => {
            this.gridApi.selection.unSelectRow(recipient);

            // at least one contact removed - dirty the form
            this.editorForm.$setDirty();

            _.remove(getRecipientsList(), {
                // Note: unsaved recipients have no ID yet
                contact: recipient.contact,
                longFormFlag: recipient.longFormFlag,
                shortFormFlag: recipient.shortFormFlag,
                applicableNetworks: recipient.applicableNetworks
            });
        });

        // defocus button
        $event.target.blur();
    };

    this.getNetworksList = (rowEntity: JS5Object) => {
        return _.map(rowEntity.applicableNetworks, 'name').sort();
    };

    const assignGridData = () => {
        if (_.isNil(getRecipientsList())) {
            if (this.modelProp) {
                _.set(this, `ngModel.${this.modelProp}`, []);
            } else {
                _.set(this, 'ngModel', []);
            }
        }

        _.set(this, 'gridOptions.data', getRecipientsList());
    };

    this.$onInit = () => {
        initGrid();
    };

    this.$onChanges = () => {
        assignGridData();
    };

}

angular.module('prism-ui.components').component(
    'emailRecipientsList',
    {
        controller: EmailRecipientsListController,
        templateUrl: 'components/visual/emailRecipientsList/email-recipients-list-template.html',
        bindings: {
            ngModel: '<',
            modelProp: '<'
        }
    });
